var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","data-server-rendered":"true"}},[_c('page-header'),_c('div',{staticClass:"page-content",class:{light: _vm.type === 'post'}},[_c('router-view')],1),(_vm.type === 'page')?_c('contact'):_vm._e(),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }